import { Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import { Form, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { getCIIU } from "../../../../redux/actions/resolucion";
import FormikActions from "../../../commons/formik/FormikActions";
import FormikAutocomplete from "../../../commons/formik/FormikAutocomplete";
import FormikTextField from "../../../commons/formik/FormikTextField";
import CharactersCounterLabel from "../../../commons/labels/CharactersCounterLabel";
import { StyledResolucion } from "../../../styled/Prevencion";
import { nuevoSectorValidation } from "./nuevoSectorValidation"

const NuevoSectorForm = ({ handleSubmit, initialValues, handleClose, open }) => {

  const dispatch = useDispatch();
  const sectores = useSelector((state) => state.resolucion.sectores.data);
  const ciiuList = useSelector((state) => state.resolucion.ciiu.data)

  return (
    <Dialog open={open} fullWidth maxWidth="sm">
      <DialogTitle>
        Nuevo Sector
      </DialogTitle>
      <Formik
        initialValues={initialValues}
        onSubmit={(values) => handleSubmit(values)}
        validationSchema={() => nuevoSectorValidation(sectores)}
      >
        {({ values, setFieldValue }) => (
          <Form>
            <DialogContent>
              <Grid container>
                <StyledResolucion.DialogGridItem item xs={12}>

                  <FormikTextField
                    name="nombre"
                    label="Nombre del Sector *"
                    fullWidth
                  />
                </StyledResolucion.DialogGridItem>
                <StyledResolucion.DialogGridItem item xs={12}>
                  <FormikAutocomplete
                    name="ciiu"
                    label="CIIU *"
                    options={ciiuList}
                    renderOption={(option) => option.nombre}
                    filterOptions={(option) => option.nombre}
                    getOptions={() => dispatch(getCIIU())}
                    multiline={true}
                  />
                </StyledResolucion.DialogGridItem>
                <StyledResolucion.DialogGridItem item xs={12}>
                  <FormikTextField
                    name="descripcion"
                    label="Descripción"
                    fullWidth
                    multiline
                    minRows={4}
                    variant="outlined"
                  />

                  <CharactersCounterLabel
                    value={values.descripcion}
                    maxCharacters={200}
                  />
                </StyledResolucion.DialogGridItem>
              </Grid>
            </DialogContent>

            <DialogActions>
              <FormikActions handleCancel={handleClose} />
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
}

export default NuevoSectorForm